const ITEMS = [
  "Handmade Pasta",
  "Dal Makhani",
  "Fresh From Our Bakery",
  "Tandoor & Wood-Fire",
  "Coffee & Mocktails",
  "Catering & Events",
  "Fatto con Amore",
];

const Marquee = () => (
  <div className="overflow-hidden border-y border-sand bg-shell py-6" data-testid="editorial-marquee" aria-hidden="true">
    <div className="marquee-track flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="font-serif italic text-2xl sm:text-3xl text-wine/25 px-8 whitespace-nowrap">{item}</span>
              <span className="h-1.5 w-1.5 rounded-full bg-brass/40" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
